import { OptionGroupProps } from './interfaces';
import styles from './styles/select.module.scss';

export function OptionGroup(props: OptionGroupProps): React.JSX.Element {
    return <div className={styles.selectOptionsGroup}>{props.children}</div>;
}
